import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";
// tslint:disable
export const yammer_praise_lightbulb: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-lightbulb" {...rest}>
      <title>praise-lightbulb</title>
      <ellipse
        transform="rotate(-88.267 74.997 75.003) scale(.99996)"
        fill="#9AC3FF"
        cx="75"
        cy="75"
        rx="75"
        ry="75"
      ></ellipse>
      <path
        fill="#FCD700"
        d="M110.9 52.2c0-19.5-17.3-35.1-38-33.8-17.8 1.2-32.1 15.1-33 32.1-.3 6 1 11.7 3.6 16.7 6.3 12.1 10.5 25 11.9 38.5l.3 2.8h39.5l.3-2.8c1.3-13.1 4.9-26 11.4-37.6 2.5-4.8 4-10.2 4-15.9z"
      ></path>
      <path
        fill="#646D7A"
        d="M66.9 109.2l-6.3-51.9c-.1-.6.1-1.1.5-1.6.4-.4.9-.7 1.5-.7H87c.6 0 1.1.2 1.5.7.4.4.6 1 .5 1.6l-5.9 51.9-4-.5L84.8 59H64.9l6 49.7-4 .5z"
      ></path>
      <path fill="#646D7A" d="M55.4 108.3h39.5V119c0 7.4-6 13.4-13.4 13.4H68.8c-7.4 0-13.4-6-13.4-13.4v-10.7z"></path>
    </svg>
  );
};
